import { getPlatform, isNativePlatform } from './platform';
import { StatusBar, Style } from '@capacitor/status-bar';
import { initDeepLinkHandler } from './deep-link-handler';
import { logEvent } from './mobile-diagnostics';
import { recordPresence } from './record-presence';

/**
 * Initialize native-specific features
 * This is called once when the app starts on native platforms
 */
export const initializeNativeFeatures = async () => {
  if (!isNativePlatform()) return;

  try {
    await logEvent({ category: 'app_lifecycle', event_type: 'app_open' });
  } catch {}

  // Initialize deep link handler for OAuth callbacks
  await initDeepLinkHandler();

  // Fallback presence call (auth listener in App.tsx is primary)
  recordPresence().catch(() => {});

  const platform = getPlatform();

  // Android: set CSS fallback for status bar height (env(safe-area-inset-top) is unreliable)
  if (platform === 'android') {
    document.documentElement.style.setProperty('--android-status-bar-height', '28px');
    document.documentElement.classList.add('is-android-native');
  }
  
  // iOS edge-to-edge
  if (platform === 'ios') {
    document.documentElement.classList.add('is-ios-native');
    await StatusBar.setOverlaysWebView({ overlay: false });
    await StatusBar.setStyle({ style: Style.Default });


    // iOS-only: tap status bar to scroll to top
    window.addEventListener('statusTap', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  console.log('Native features initialized');
};
